module.exports = __webpack_public_path__ + "img/25.9.TU.b810605e.png";